module.exports = __webpack_public_path__ + "fonts/80d5d972/proxima_nova_bold-latin-a.woff";